import { IUser } from './user.interfaces';
import axios from 'axios';
import { BaseService } from '@/features/base/api/base.api';

class UserService extends BaseService {
  private static instance: UserService;

  private constructor() {
    super();
  }

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public getUser(): Promise<IApi<IUser>> {
    return this.get<IUser>(`${this.baseUrl}/api/user`);
  }

  public getUsers(): Promise<IApi<IUser[]>> {
    return this.get<IUser[]>(`${this.baseUrl}/api/admin/users`);
  }

  public delete(id: string): Promise<IApi<string>> {
    return this.deleteItem<string>(`${this.baseUrl}/api/user/${id}`);
  }
}

export const userService = UserService.Instance;
